import * as React from "react";

export const Loader = (props: any) => {
  if (props.loading) {
    return (
      <div
        style={{
          display: "block",
          position: "absolute",
          left: 0,
          right: 0,
          background: "rgba(255,255,255,0.7)",
          transition: "all .3s ease",
          top: 0,
          bottom: 0,
          textAlign: "center"
        }}
      >
        <div className="text-center">
          <div className="spinner-grow text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="spinner-grow text-danger" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <div className="spinner-grow text-success" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
